export default {
  home: {
    minute: "minuto",
    hour: "hora",
    days: "dias",
    price_info:
      "Os primeiros {mianfei} minutos são grátis. A cobrança máxima por 24 horas é {currencyName}{fengding}. O seu depósito {currencyName}{yajin} será reembolsado automaticamente após devolver a power bank",
    feature_1: "Inclui todos os tipos de cabos: iPhone, Type‑C",
    feature_2: "Pode ser devolvido em qualquer estação",
    feature_3: "Carregamento sem fios disponível",
    tips_1:
      "O seu depósito {currencyName}{yajin} será devolvido no fim do aluguer",
    tips_2:
      "O depósito de recarga {currencyName}{yajin} pode ser usado para aluguer e, quando esgotado, pode ser reembolsado",
    tips_3:
      "O saldo atual é {currencyName}{myyue}, que pode ser usado diretamente para aluguer",
    submit: "Iniciar aluguer",
    borrow: "Alugar",
    msg_fail_title: "Erro",
    msg_fail_content: "Falha no aluguer, tente novamente",
    msg_rentcount: "Tem {zujieNum} pedidos que não foram encerrados",
    goborrow: "Ir carregar!!!",
    nearby: "Ver estações próximas",
    preauth: "Pré‑autorização"
  },
  login: {
    code_title: "Verificação por SMS",
    phone_number: "Número de telefone",
    verification_code: "Introduza o código de verificação do SMS",
    captcha_code: "Código",
    send_code: "Enviar código",
    login: "Iniciar sessão",
    agree: "Ao clicar em Iniciar sessão, concorda com ",
    readme: "o Acordo do Utilizador",
    msg_fail_login: "Falha no início de sessão",
    msg_success_login: "Sessão iniciada com sucesso",
    msg_fail_user:
      "Erro ao obter as informações do utilizador. Quer tentar novamente?",
    sign_in_with: "Iniciar sessão com",
    no_sms: "Não recebeu a mensagem",
    retry: "Reenviar"
  },
  confirm: {
    deletecard: "Eliminar cartão",
    addcard: "Introduzir dados do cartão",
    title: "Confirmação de pagamento",
    paynow: "Pagamento imediato",
    SMSConfirm:
      "Por favor, pague de acordo com a mensagem recebida no telefone e clique em confirmar para continuar.",
    pay_label: "Montante",
    auth_label: "Pré‑autorização",
    price_tips:
      "O seu saldo pode ser levantado se solicitado. Pode demorar 1‑5 dias úteis a aparecer na sua conta de pagamento.",
    auth_tips:
      "É obrigatória uma pré‑autorização de {0}{1}. O valor real do aluguer será deduzido quando a power bank for devolvida.",
    pay_type: "Selecione o método de pagamento preferido",
    submit: "Confirmar pagamento",
    msg_loading: "A carregar...",
    msg_fail_title: "Aviso",
    msg_fail_payment: "Falha ao iniciar o pagamento do depósito",
    msg_fail_order: "Falha ao criar o pedido de aluguer",
    msg_fail_support: "Sistema não suportado",
    msg_fail_confirm: "Confirmar",
    msg_fail_retry: "Tentar novamente",
    msg_fail_cancel: "Cancelar"
  },
  mine: {
    title: "Perfil do utilizador",
    wallet: "A minha carteira",
    balance: "O meu saldo",
    deposit: "Depósito",
    wallet_in: "Carregar",
    wallet_out: "Levantar",
    wallet_log: "Registo da carteira",
    rental_history: "Histórico de alugueres",
    payment_title: "Métodos de pagamento",
    download_app: "Transferir a app",
    settings: "Definições",
    help: "Ajuda",
    logout: "Terminar sessão",
    login_tips: "Inicie sessão",
    msg_fail_title: "Erro",
    msg_fail_update: "A alteração falhou. Tente novamente",
    msg_loading: "A carregar...",
    msg_fail_user:
      "Erro ao obter as informações do utilizador. Quer tentar novamente?",
    edit_profile: "Editar perfil",
    join_us: "JUNTE‑SE A NÓS",
    join_us_details: "Obtenha uma estação Cargamos no seu espaço"
  },
  msg: {
    appoffline: "A app ainda não foi lançada, por favor aguarde",
    deletecard: "Tem a certeza de que quer eliminar este cartão?",
    no_phone: "O número de telefone é obrigatório",
    loading: "A carregar...",
    title: "Dica",
    success: "Operação concluída",
    error: "Erro desconhecido. Tente novamente mais tarde",
    roleerror: "Permissões insuficientes. Consulte o administrador.",
    neterror: "Falha na ligação de rede. Tente novamente mais tarde",
    confirm: "Confirmar",
    retry: "Tentar novamente",
    cancel: "Cancelar",
    title_fail: "Aviso",
    vieworder: "Ver pedido",
    success_payment: "Pagamento concluído",
    success_buy: "Compra concluída",
    fail_payment: "Falha no pagamento",
    keyword: "Palavra‑chave",
    ispayorder: "Confirme se o pagamento foi efetuado",
    unpay: "Não pago",
    yespay: "Pago",
    notopen: "Ainda não aberto"
  },
  result: {
    tips:
      "Para ver pedidos e outras localizações de estações, transfira a aplicação.",
    download: "Transferir a app",
    title: "Aluguer confirmado",
    gotit: "Entendi",
    price_plan: "Tarifa",
    msg_success: "Aluguer efetuado com sucesso",
    msg_tips_loading: "A power bank está a ser ejetada, aguarde...",
    msg_result_loading: "O resultado do pagamento está a ser confirmado...",
    msg_fail_confirm: "Confirmar",
    btn_usage: "Nota de utilização",
    btn_return: "Nota de devolução",
    deposit: "Depósito",
    msg_fail_content: "O pedido falhou. Tente novamente.",
    price_label: "por hora",
    price_info:
      "Os primeiros {mianfei} minutos são gratuitos, a taxa diária máxima é {ccurrency}{fengding}. O depósito será deduzido automaticamente quando o aluguer atingir {ccurrency}{yajin}",
    tips_1:
      "Por favor, recolha a power bank n.º {number} conforme mostrado na imagem",
    tips_2:
      "Organize os cabos e insira a power bank na ranhura com o lado marcado com [setas para baixo]",
    msg_note_usage:
      "A power bank está equipada com 3 tipos de cabos, escolha o adequado ao seu dispositivo.",
    msg_note_return:
      "Organize os cabos e insira a power bank na ranhura com o lado marcado com [setas para baixo]",
    return_info:
      "Ao devolver, certifique‑se de que os cabos estão organizados e insira o lado com contactos metálicos numa ranhura disponível até ao fundo.",
    download_tips:
      "Para alugar a nossa powerbank, pode escolher uma das seguintes opções"
  },
  result_msg: {
    loading: "A carregar...",
    refresh: "Atualizar"
  },
  order: {
    title: "Histórico de alugueres",
    in_use: "Em uso",
    ended: "Terminados",
    msg_error: "O pedido falhou",
    order_number: "N.º",
    order_details: "Detalhes do pedido",
    order_zj_shop: "Local de aluguer",
    order_zj_time: "Hora de aluguer",
    order_gh_shop: "Local de devolução",
    order_gh_time: "Hora de devolução",
    order_use_time: "Tempo de utilização",
    order_amount: "Valor total",
    not_on_rent: "Não alugado",
    renting: "Em aluguer",
    undone: "Não concluído",
    returned: "Devolvido",
    questions: "Perguntas",
    timeout_to_return: "Tempo limite para devolução",
    suspended_for_billing: "Suspenso para faturação"
  },
  order_item: {
    order_number: "N.º",
    venue_rented: "Local de levantamento",
    time_rented: "Hora de levantamento",
    venue_returned: "Local de devolução",
    time_returned: "Hora de devolução",
    charge_standard: "Tarifa",
    charge_standard_info:
      "{pJifei} {pCurrency} por hora (primeiros {pMian} min grátis)",
    rent_occurred: "Aluguer efetuado",
    returned: "Devolvido",
    unreturned: "Não devolvido",
    type_0: "Não concluído",
    type_1: "Em aluguer",
    type_2: "Cancelado",
    type_3: "Devolvido",
    type_4: "Ocorreu um erro",
    type_5: "Fora do prazo",
    min: "min",
    payment: "Pagamento"
  },
  setting: {
    title: "Definições",
    lang: "Idioma"
  },
  help: {
    title: "FAQ",
    rentals: "Alugueres",
    venues: "Locais",
    payments: "Pagamentos"
  },
  wallet_in: {
    title: "Recarga de saldo",
    price_label: "Montante de recarga",
    price_placeholder: "Introduza o montante de recarga",
    balance: "Saldo atual",
    price_auto: "Escolher montante de pagamento",
    price_tips:
      "O seu saldo pode ser levantado se solicitado. Pode demorar 1‑5 dias úteis a aparecer na sua conta de pagamento.",
    submit: "Enviar",
    loading: "A carregar...",
    paying: "A redirecionar para a página de pagamento...",
    msg_title: "Dicas",
    msg_fail_order: "Falha ao criar o pedido de recarga",
    msg_fail_payment: "Falha ao iniciar o pagamento da recarga",
    msg_fail_retry: "Tentar novamente"
  },
  wallet_out: {
    title: "Levantamento",
    price_label: "Montante de levantamento",
    price_placeholder: "Introduza o montante de levantamento",
    balance: "Saldo atual",
    balance_all: "Levantar tudo",
    deposit: "Depósito",
    deposit_tips:
      "Existe um pedido de aluguer pendente. O depósito de Ksh{pyajin} não é reembolsável",
    submit: "Enviar",
    apply: "Submeter",
    confirm: "Confirmar",
    loading: "A carregar...",
    msg_fail_price: "O montante de levantamento está incorreto",
    msg_fail_balance:
      "O montante de levantamento não pode exceder o saldo atual",
    msg_fail_submit: "Por favor, preencha todas as informações obrigatórias",
    msg_title: "Erro",
    msg_success_content: "Reembolso bem‑sucedido",
    confirmtitle: "Dicas",
    confirmcontent:
      "A carteira atual não suporta levantamento em dinheiro. Deixe a sua informação de contacto para processamento manual do reembolso",
    payee_name: "Nome do beneficiário",
    payee_bankcard: "Número do cartão bancário",
    payee_phone: "Telefone",
    cancelText: "Cancelar",
    confirmText: "Submeter novamente"
  },
  map: {
    在线: "Aberto",
    离线: "Fechado",
    title: "Estação próxima",
    result_msg: "Nenhuma estação encontrada nas proximidades",
    msg_title: "erro",
    no_support: "Desculpe! O seu navegador não suporta serviços de localização",
    my_position: "A minha localização",
    distance: "Distância:",
    shop_time: "Horário",
    free: "Disponível para aluguer",
    return: "Ranhuras vazias disponíveis",
    shop_title: "Detalhes do local",
    address: "Endereço",
    go_here: "Ir aqui",
    nav_help: "Ajuda",
    nav_search: "Pesquisar"
  },
  scanQr: {
    NotAllowedError: "Precisa conceder acesso à câmara",
    NotFoundError: "Não há câmara neste dispositivo",
    NotSupportedError: "É necessário um contexto seguro (HTTPS, localhost)",
    NotReadableError: "A câmara está em uso",
    OverconstrainedError: "A configuração da câmara não é adequada",
    StreamApiNotSupportedError: "Este navegador não suporta a API de streaming"
  },
  payment: {
    payment_title: "Métodos de pagamento",
    pay_type: "Adicione os dados do seu cartão",
    add_payment_card: "Adicionar cartão de pagamento",
    add_payment: "adicionar pagamento"
  },
  shop: {
    title: "Estação próxima",
    search_station: "Pesquisar uma estação",
    search_station_tips: "Introduza o nome da estação",
    shop_power_banks: "Power banks",
    shop_empty_slots: "Ranhuras vazias",
    shop_address: "Endereço",
    shop_business_hours: "Horário de funcionamento",
    shop_directions_station: "Obter direções para a estação",
    shop_scan_qrcode: "Digitalizar QR"
  },
  paymethod: {
    payamount: "Montante a pagar",
    choosepaymethod: "Escolher opções de pagamento",
    addcard: "Adicionar novo cartão",
    confrimpay: "Confirmar pagamento",
    借记卡: "Cartão de débito",
    银行卡列表: "Lista de cartões bancários"
  },
  orderDetail: {
    price1: "{pJifei} {pCurrencyName} por {pJifeiDanwei} {priceUnit}",
    price2: "Até {pFengding} {pCurrencyName} por 24 horas",
    price3: "Taxa por não devolução de {overtimeAmount} {pCurrencyName}",
    venuerented: "Local de aluguer",
    venuereturned: "Local de devolução",
    timerented: "Hora de aluguer",
    timereturned: "Hora de devolução",
    powerbankid: "ID da power bank",
    getreceipt: "OBTER RECIBO",
    buypowerbank: "Comprar esta power bank",
    usetime: "Tempo de utilização",
    estimatedamount: "Montante estimado",
    feerule: "Regra de tarifa",
    payment: "Pagamento",
    orderNo: "N.º do pedido",
    trafficDetails: "Ver detalhes de tráfego do pacote",
    Renewals: "Renovações",
    FeeSchedule: "Tabela de tarifas",
    HowToUse: "Como usar",
    LeaseMerchant: "Arrendador",
    startTime: "Hora de início",
    ReturningMerchants: "Locais de devolução",
    EndTime: "Hora de fim",
    Deposit: "Depósito",
    fee1: "Depósito do equipamento {overtimeAmount} {pCurrencyName}",
    fee2:
      "Devolvido dentro de {overtime} dias após a data de expiração do aluguer, menos {pFengding} {pCurrencyName} por 24 horas.",
    fee3:
      "Se o equipamento for devolvido dentro de {overtime} dias após o período de aluguer expirar, será deduzido {overtimeAmount} {pCurrencyName}.",
    fee4:
      "O depósito será deduzido automaticamente se o equipamento não for devolvido mais de 15 dias após o fim dos dias de aluguer.",
    rentagain: "Alugar novamente",
    onrental: "Em aluguer",
    revoked: "Revogado",
    returned: "Devolvido",
    issue: "Problema",
    overtimereturn: "Fora do prazo"
  },
  selectpackage: {
    powerbank: "Power bank",
    powerstation: "Estação",
    wifibox: "Caixa Wi‑Fi",
    choosepackage: "Escolher um pacote de tráfego",
    minute: "minuto",
    首次免费: "Grátis nos primeiros ",
    最大每日收费: "Cobrança diária máxima ",
    devicedeposit: "Depósito do equipamento",
    return_will_back: "Devolver o depósito após devolver o equipamento",
    lengthofuse: "Duração de uso",
    amountcharged: "Montante acumulado",
    release_powerbank: "Libertar a sua power bank",
    see_pricing: "Ver preços",
    deposit: "depósito",
    agreen: "Ao continuar, concorda com a nossa ",
    privacy_policy: "Política de Privacidade",
    and: " e ",
    terms_and_conditions: "Termos e Condições.",
    per: "por",
    tips_1: "depósito de {currencyName} {yajin} será devolvido",
    tips_2:
      "Após {pOvertimeDay} dias será cobrado {currencyName} {overtimeAmount}"
  },
  rentcost: {
    rentcosttitle: "Quanto custa o aluguer?",
    price1: "{currency} {jifei} por {jifeiDanwei} {priceUnit}",
    price2: "{currency} {fengding} por dia",
    tip1:
      "Se não devolver a power bank dentro de {overtime} dias, será cobrado {overtimeAmount} {currency} e não precisa devolvê‑la.",
    tip2:
      "Um dia de aluguer são 24 horas a partir do momento em que a power bank é alugada.",
    tip3:
      "Cobraremos {yajin} {currency} como depósito de segurança, que será devolvido quando a bateria for devolvida à estação.",
    tip4:
      "Alguns locais podem oferecer algumas horas grátis ou descontos. Aproveite!",
    Days: "Dias",
    Hours: "Horas",
    Minutes: "Minutos",
    free: "{mianfei} minutos grátis",
    willcharged: "Será cobrado {currency} {money}"
  }
};
